module.exports = __webpack_public_path__ + "img/header-productos.d4005cda.jpg";